import SingleAdminMemo from './SingleAdminMemo';

export default SingleAdminMemo;
